module.exports = __webpack_public_path__ + "static/media/play-board-intro-3.ad8a7bc0.png";